import { render } from "./MerchantOrderDetailsPage.vue?vue&type=template&id=52060aec&ts=true"
import script from "./MerchantOrderDetailsPage.vue?vue&type=script&lang=ts"
export * from "./MerchantOrderDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__